import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SharedHttpService } from '../../services/shared-http.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'app-general-violations',
    templateUrl: './general-violations.component.html',
    styleUrls: ['./general-violations.component.scss']
})
export class GeneralViolationsComponent implements OnInit {
    violationList: any = [];
    @Input() loadDataFP: Observable<any>;
    infoView = new BehaviorSubject<any>('');
    getUrl: string;
    ViolationDetails: any;
    ViolationInfo: any;
    ViolationPenalties: any;
    ViolationAttachments: any;
    doc: any = "";
    pdfFile = false;
    image: any;
    ViolationObjections: any;
    eViolationId: any;
    reasons: any;
    requests: any;
    MemberForViolations: any;
    eMemebrId: any;
    MemebrId: any;
    requestStatusId: any;
    eObjectionRequestId: any;
    AttachmentList: any;
    ObjectionRequest: any;
    IsReadonly: boolean = false;
    requestId: any;
    ObjectionByMemberAndViolation: any;
    Loader: boolean = false;
    selectedFile: any;
    stepOneDone: boolean = false;
    stepTwoDone: boolean = false;

    eRequestId: any;
    allowSend: boolean = false;
    isAttachUpload: boolean = false;
    currentUserRoleId: any;
    currentUserId: any;
    loadViolationDetails = new BehaviorSubject<any>('');
    attachmentTypeId: any;
    otherTypeInfo: any="";
    atachTypesArr: any;


    constructor(private sharedService: SharedHttpService, private sanitizer: DomSanitizer, public router: Router) {
        (window as any).pdfWorkerSrc = '/assets/pdfjs/pdf.worker.min.js';
     }

    ngOnInit(): void {
        this.Loader = false;
        this.currentUserRoleId=JSON.parse(localStorage.getItem('user')).roleId;
        this.currentUserId = JSON.parse(localStorage.getItem('user')).userId;
        if (this.loadDataFP) {
            this.loadDataFP.subscribe((data) => {

                if (data != null && data.violations != null) {
                    this.violationList = data.violations;
                }

            });
        }
       
       
        this.sharedService.get(`api/ObjectionRequest/GetAttchmentTypes`).subscribe((res) => {
        this.atachTypesArr=res;
    });
        this.infoView.next({});


    }

    GotoViolationDetails(eViolationId, ViolationDetails) {
        this.getUrl = `api/Violation/GetViolationDetails?eViolationId=${eViolationId}`;
        this.sharedService.get(this.getUrl).subscribe((res) => {
            this.ViolationDetails = res;
            //console.log(this.ViolationDetails.violation);
            //this.ViolationInfo = this.ViolationDetails.violation;
            //this.ViolationPenalties = this.ViolationDetails.penalties;
            //this.ViolationAttachments = this.ViolationDetails.violationAttachments;
            this.ViolationObjections = this.ViolationDetails.objections;
            this.loadViolationDetails.next({ ViolationDetails : res});
             this.sharedService.openXLarge(ViolationDetails);

        });
      
    }

    GotoObjectionsDetails(eViolationId, ObjectionsDetails) {

        this.getUrl = `api/Violation/GetViolationDetails?eViolationId=${eViolationId}`;
        this.sharedService.get(this.getUrl).subscribe((res) => {
            this.ViolationDetails = res;
            this.ViolationInfo = this.ViolationDetails.violation;
            this.ViolationPenalties = this.ViolationDetails.penalties;
            this.ViolationAttachments = this.ViolationDetails.violationAttachments;
            this.ViolationObjections = this.ViolationDetails.objections;


        });

        this.sharedService.openXLarge(ObjectionsDetails);
    }
    downloadFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.mimeType });
        var url = window.URL.createObjectURL(blob);

        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = attachment.fileName;
        fileLink.click();
    }
    download(attachment) {
        let url = `api/Violation/DownloadViolationFile?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.downloadFile(data, attachment);
        });
    }





    
    download2(attachment) {
        let url = `api/ObjectionRequest/DownloadObjectionFile?eObjectionAttachmentId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.downloadFile(data, attachment);
        });
    }






    previewPDF2(attach, pdfmodal) {

        this.sharedService.openLarge(pdfmodal);
        this.show2(attach);
    }


    show2(attachment) {
        let url = `api/ObjectionRequest/DownloadObjectionFile?eObjectionAttachmentId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.ShowFile(data, attachment);
        });
    }


    previewPDF(attach, pdfmodal) {

        this.sharedService.openLarge(pdfmodal);
        this.show(attach);
    }
    show(attachment) {
        let url = `api/Violation/DownloadViolationFile?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.ShowFile(data, attachment);
        });
    }
    ShowFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: 'application/pdf' });
        var url = window.URL.createObjectURL(blob);
        this.doc = url;

       // this.pdfFile = true;
        if (attachment.fileName.endsWith('.pdf')) {
            this.pdfFile = true;
        } else {
            this.pdfFile = false;
            this.image = this.sanitizer.bypassSecurityTrustUrl(url)
        }
    }


    makeObjection(eViolationId, addObjection) {
        this.MemebrId = '';
        this.reasons = '';
        this.requests = '';
        this.eViolationId = eViolationId;
        this.getUrl = `api/Violation/GetMemberForViolations?eViolationId=${eViolationId}`;
        this.sharedService.get(this.getUrl).subscribe((res) => {
            this.MemberForViolations = res;
        });
        //this.AttachmentList = [];
        this.stepOneDone = false;
        this.stepTwoDone = false;
        this.sharedService.openLarge(addObjection);
    }
    selectMemberViolation(e) {
        this.eMemebrId = e.more;
        this.MemebrId = e.id;
        let obj = {
            "eViolationId": this.eViolationId,
            "eMemberId": this.eMemebrId
        }
        this.sharedService.post('api/ObjectionRequest/GetObjectionByMemberAndViolation', obj).subscribe(res => {
            this.ObjectionByMemberAndViolation = res;
            if (res != null) {
                this.requestStatusId = res.requestStatusId;
                if (this.requestStatusId == 1) {
                    this.IsReadonly = false;
                    this.reasons = res.reasons;
                    this.requests = res.requests;
                    this.requestId = res.requestId;
                    this.eRequestId = res.eRequestId;

                }
                if (this.requestStatusId != 1) {
                    this.IsReadonly = true;
                    this.reasons = res.reasons;
                    this.requests = res.requests;
                }

            }

        });
    }

    onCreateObjection() {
        let obj = {
            "reasons": this.reasons,
            "requests": this.requests,
            "eViolationId": this.eViolationId,
            "memebrId": this.MemebrId,
            "eMemebrId": this.eMemebrId
        }
        this.sharedService.post('api/ObjectionRequest/AddEditRequest', obj).subscribe(res => {
            this.eObjectionRequestId = res.eObjectionRequestId;
            if (res.receptionStatus == true)
               { this.sharedService.showSuccessKey(res.moreInfo);
                this.stepOneDone = true;}

            else
                this.sharedService.showErrorKey(res.moreInfo);

          


        });
    }

    onEditObjection() {
        let obj = {
            "requestId": this.requestId,
            "reasons": this.reasons,
            "requests": this.requests,
            "eViolationId": this.eViolationId,
            "memebrId": this.MemebrId,
            "eMemebrId": this.eMemebrId
        }
        this.sharedService.post('api/ObjectionRequest/AddEditRequest', obj).subscribe(res => {
            this.eObjectionRequestId = res.eObjectionRequestId;
            this.stepTwoDone = true;

            if (res.receptionStatus == true)
                this.sharedService.showSuccessKey(res.moreInfo);
            else
                this.sharedService.showErrorKey(res.moreInfo);
            this.sharedService.get(`api/ObjectionRequest/GetAttachmentList?eObjectionRequestId=${this.eObjectionRequestId}`).subscribe((res) => {
                this.AttachmentList = res;
              
            });

            // this.sharedService.get(`api/ObjectionRequest/SendObjectionRequest?eObjectionRequestId=${this.eObjectionRequestId}`).subscribe((res) => {
            //     this.ObjectionRequest = res;
            //     console.log(res);
            // });
        });
    }

    onSendObjection(modal) {
        this.sharedService.get(`api/ObjectionRequest/SendObjectionRequest?eObjectionRequestId=${this.eObjectionRequestId}`).subscribe((res) => {
            this.ObjectionRequest = res;
            if (res.receptionStatus == true)
                this.sharedService.showSuccessKey(res.moreInfo);

            else
                this.sharedService.showErrorKey(res.moreInfo);

        });
        modal.dismiss('Cross click');

    }
    checkConfirm(allowSend) {
        console.log(allowSend)
    }
   


    upload(model) {


        this.sharedService.openSmall(model);
    }
    selectFile(file: any) {
        this.selectedFile = file;
        // this.UploadFile();
  
    }

    UploadFile(modal) {
        this.Loader = true;
        if (!this.checktype(this.selectedFile.target.files[0].name)) {
            this.sharedService.showErrorKey("FileExtCheck");
            return;
        }
        let formData: FormData = new FormData();
        let url = "";
        formData.append('reportProgress', 'true');
        formData.append('observe', 'events');
        formData.append('file', this.selectedFile.target.files[0]);
        formData.append('eObjectionRequestId', this.eObjectionRequestId);
        formData.append('fileType', this.selectedFile.target.files[0].type);
        formData.append('isinternal', 'false');
        formData.append('attachmentTypeId', this.attachmentTypeId);
        formData.append('otherName', this.otherTypeInfo);
  
  
        url = `api/ObjectionRequest/UploadAttachment`;
        this.sharedService.post(url, formData).subscribe(results => {
            modal.dismiss('Cross click');
            if (results.receptionStatus == true){
              this.sharedService.showSuccessKey(results.moreInfo);
              this.sharedService.get(`api/ObjectionRequest/GetAttachmentList?eObjectionRequestId=${this.eObjectionRequestId}`).subscribe((res) => {
                this.AttachmentList = res;
            this.selectedFile = undefined;
              
            });
            this.isAttachUpload=true;

        }
            else
                this.sharedService.showErrorKey(results.moreInfo);
  
            this.Loader = false;
  
        });
    }
  
  
    loadscanner: Subject<any> = new Subject<any>();

    isScan: boolean = false;
    scan(modal) {
        this.sharedService.openXLarge(modal);
        this.isScan = true;
        setTimeout(() => {
            this.loadscanner.next({});
        }, 100);

    }
    hidescan(modal) {
        this.isScan = false;
        modal.dismiss('Cross click');

        this.sharedService.get(`api/ObjectionRequest/GetAttachmentList?eObjectionRequestId=${this.eObjectionRequestId}`).subscribe((res) => {
            this.AttachmentList = res;

        });
        // this.loadData();
    }
    checktype(name) {
        var ext = name.split('.').pop();

        if (ext == "doc"
            || ext == "docx"
            || ext == "xls"
            || ext == "xlsx"
            || ext == "ppt"
            || ext == "pptx"
            || ext == "png"
            || ext == "jpg"
            || ext == "jpeg"
            || ext == "tiff"
            || ext == "pdf"
            || ext == "svg"
            || ext == "bmp"
            || ext == "ico"
            || ext == "mp4" || ext == "avi" || ext == "mpeg" || ext == "dat" || ext == "mp3"

        )
            return true;
        else
            return false;
    }
    GotoObjectionsViolationDetails(eRequestId, modal) {
        let url: string =
            '/objections/details/' + eRequestId +'/objections';
        this.router.navigate([url]);
        modal.dismiss('Cross click');

    }
}
